<template>
  <v-text-field v-mask="mask" v-bind="$attrs" v-on="$listeners">
    <slot v-for="(_, name) in $slots" :slot="name" :name="name" />
  </v-text-field>
</template>

<script>
import {mask} from 'vue-the-mask'

export default {
  directives: {mask},
  props: {
    mask: {
      type: String,
      default: '',
    },
  },
}
</script>
